import keyMirror from "keymirror"

export default keyMirror({
  UI_DRAWING_SCREEN_SHOW: null,
  UI_REPLAY_SCREEN_SHOW: null,
  PROGRAM_SAVE: null,
  PROGRAM_LOAD: null
})



// WEBPACK FOOTER //
// ./src/const/ActionTypes.js